import { MediaBoxComponent } from './mediabox';
import { Component, Injector, Input } from '@angular/core';
import { Events } from 'ionic-angular';
import { Domanda } from '../../app/domanda';
import { EthemeProvider } from '../../providers/etheme/etheme';
import { Domanda_super } from './domanda_super';

/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'feedbackgenerico',
  templateUrl: 'feedbackgenerico.html', 
})

export class FeedbackGenericoComponent extends Domanda_super{

  @Input('domanda') domanda: any;
  @Input('mq') mq: any;
  @Input('settingsmq') settingsmq: boolean;
  
  risp: any = '';
  feed = '';
  showconferma: boolean = true;
  showfeed: boolean = false;
  showtime: boolean = true;
    alloro:string = '<div><img src="assets/icon/alloro.svg" class="alloro_"></div>';
  constructor(public events: Events,inj:Injector) {
    super(inj); 
  }
  ngOnInit(): void {

    // this.events.publish('start_tempo', this.domanda);
    // if (this.domanda.durataMinima != '0') {
    //   this.showtime = false;
    // }
    // this.events.subscribe('tempo_' + this.domanda.id, (tipotempo) => {
    //   if (tipotempo == 'minima')
    //     this.showtime = true;
    //   else if (tipotempo == 'massima')
    //     this.conferma('tempo');
    // });
  }
  
  prosegui() {
    this.events.publish('next_feedback_generico', this.domanda);

  }
  
}



// WEBPACK FOOTER //
// ./src/pages/msteps/feedbackgenerico.ts